import ConfirmDeleteDialog from "../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog";
import type { SubTopicDatabase } from "../../../../types";
import { useDeleteSubTopicModal } from "./useDeleteSubTopicModal";

// Keeps the French quotes and question mark on the sub-topic name's line.
const NBSP = ' ';

type Props = {
  subTopic: SubTopicDatabase;
  onClose: () => void;
}

export default function DeleteSubTopicModal(props: Props) {
  const hook = useDeleteSubTopicModal(props);

  return (
    <ConfirmDeleteDialog
      title="Supprimer le sous-sujet"
      onConfirm={hook.handleConfirm}
      onClose={props.onClose}
    >
      Supprimer le sous-sujet «{NBSP}{props.subTopic.name}{NBSP}»{NBSP}?
    </ConfirmDeleteDialog>
  );
}
